import HomePage from 'components/Home/HomePage'
export default HomePage
